import { ApiService, type ApiRequestConfig } from "./api.service";
import type { TAuditEventDetail, TAuditEventsListQuery, TAuditEventsPage } from "@/types/audit";

type TAuditExportQuery = Omit<TAuditEventsListQuery, "per_page" | "cursor">;

export class AuditService extends ApiService {
  async list(
    slug: string,
    params: TAuditEventsListQuery = {},
    config?: ApiRequestConfig,
  ): Promise<TAuditEventsPage> {
    return this.get(`/api/workspaces/${slug}/audit-events/`, { ...config, params });
  }

  /** Download the audit log as a CSV blob (server-rendered), scoped to the same
   *  filters and — when `ids` is non-empty — restricted to the selected rows.
   *  Builds the query string explicitly so `ids` repeats as `ids=a&ids=b` (the
   *  shape Django's `getlist` expects), not the bracketed array axios defaults to. */
  async exportCsv(slug: string, params: TAuditExportQuery = {}, ids: string[] = []): Promise<Blob> {
    const search = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null && value !== "") search.set(key, String(value));
    }
    for (const id of ids) search.append("ids", id);
    const qs = search.toString();
    return this.get(`/api/workspaces/${slug}/audit-events/export/${qs ? `?${qs}` : ""}`, {
      responseType: "blob",
    });
  }

  /** A single event with its per-field changes, for the diff side panel. */
  async getEvent(slug: string, id: string): Promise<TAuditEventDetail> {
    return this.get(`/api/workspaces/${slug}/audit-events/${id}/`);
  }
}
